import {
  CalendarBlank,
  CalendarCheck,
  ClockCounterClockwise,
  Database,
  FolderPlus,
  Info,
} from "@phosphor-icons/react"

import { type BadgeVariant } from "~/components/reusable/Badge"
import { InboxRecommendation, type InboxRecommendationType } from "~/constants/npi"

export type RecommendationActionKind =
  | "phaseOut"
  | "addToCollection"
  | "updateActivation"
  | "handleInErp"

export type RecommendationDescriptor = {
  label: string
  badgeVariant: BadgeVariant
  icon: React.ReactNode
  actionKind: RecommendationActionKind
  displayOrder: number
}

export const recommendationDescriptors: Record<InboxRecommendationType, RecommendationDescriptor> =
  {
    [InboxRecommendation.AddToCollection]: {
      label: "Add to collection",
      badgeVariant: "green",
      icon: <FolderPlus size={14} weight="bold" />,
      actionKind: "addToCollection",
      displayOrder: 0,
    },
    [InboxRecommendation.PhaseOut]: {
      label: "Phase out",
      badgeVariant: "red",
      icon: <ClockCounterClockwise size={14} weight="bold" />,
      actionKind: "phaseOut",
      displayOrder: 1,
    },
    [InboxRecommendation.SetActivation]: {
      label: "Set activation",
      badgeVariant: "violet",
      icon: <CalendarBlank size={14} weight="bold" />,
      actionKind: "updateActivation",
      displayOrder: 2,
    },
    [InboxRecommendation.ReviewActivation]: {
      label: "Review activation",
      badgeVariant: "violet",
      icon: <CalendarCheck size={14} weight="bold" />,
      actionKind: "updateActivation",
      displayOrder: 3,
    },
    [InboxRecommendation.HandleInErp]: {
      label: "Handle in ERP",
      badgeVariant: "yellow",
      icon: <Database size={14} weight="bold" />,
      actionKind: "handleInErp",
      displayOrder: 4,
    },
    [InboxRecommendation.ReviewSystemDate]: {
      label: "Review activation date",
      badgeVariant: "default",
      icon: <Info size={14} weight="bold" />,
      actionKind: "updateActivation",
      displayOrder: 5,
    },
  }
